import * as actionTypes from "../consts/actionTypes";

/**acciones que se disparan del componente */
export function getCards() {
    return {
        type: actionTypes.GET_CARDS,
        payload: '',
    };
}